var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93923 7.08644C4.72696 6.88551 4.38883 6.89184 4.18509 7.10226C3.98136 7.31269 3.98829 7.64652 4.20109 7.84798L6.8011 10.3119C6.90456 10.4095 7.03736 10.4585 7.17017 10.4585C7.30883 10.4585 7.44803 10.4047 7.55203 10.2987L11.8187 5.96945C12.0246 5.76114 12.0198 5.4273 11.8091 5.22374C11.5979 5.02069 11.2608 5.02491 11.055 5.23376L7.15736 9.18805L4.93923 7.08644ZM14.4131 11.7256L7.99978 16.7995L1.5859 11.7256L1.08456 2.43576C1.93523 2.05816 4.52137 1.05667 7.99978 1.05667C11.4777 1.05667 14.0638 2.05816 14.9145 2.43576L14.4131 11.7256ZM15.7176 1.64437C15.5901 1.57687 12.5453 0 8.00027 0C3.45466 0 0.40985 1.57687 0.282383 1.64437C0.0994488 1.74035 -0.0104181 1.93285 0.000781911 2.13747L0.534116 12.0158C0.542116 12.1661 0.61465 12.3054 0.733584 12.3998L7.66693 17.8845C7.76453 17.9615 7.88187 18 8.00027 18C8.11813 18 8.23547 17.9615 8.33307 17.8845L15.2664 12.3998C15.3854 12.3054 15.4579 12.1661 15.4659 12.0158L15.9992 2.13747C16.0104 1.93285 15.9006 1.74035 15.7176 1.64437Z",
    fill: "#1F1A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.e4812b048cb0bee6f5c716c96023bf0a.svg";
export { ForwardRef as ReactComponent };